/*
 * @Author: your name
 * @Date: 2021-05-21 16:09:59
 * @LastEditTime: 2021-07-23 11:37:26
 * @LastEditors: Please set LastEditors
 * @Description: 运维定制页面时所需头部数据，与实际门户除path中多“edit”之外完全一致
 * @FilePath: \NavDemo\src\router.config.js
 */

export default [{
    'path': '/edit',
    'component': 'layout/EditLayout',
    'redirect': {
        "name": "/edit/Home"
    },
    "children": [{
            "path": "/edit/Home",
            "name": "Home",
            "component": 'home/Home',
            "meta": { "key": "Home" }
        }, {
            "path": "/edit/BigThing",
            "name": "BigThing",
            "component": 'bigThing/BigThing',
            "meta": { "key": "BigThing" }
        }, {
            "path": "/edit/Overview",
            "name": "Overview",
            "component": 'overview/Overview',
            "meta": { "key": "Overview" }
        }, {
            "path": "/edit/LeaderRecord",
            "name": "LeaderRecord",
            "component": 'leaderRecord/LeaderRecord',
            "meta": { "key": "LeaderRecord" }
        }, {
            "path": "/edit/SpecialReport",
            "name": "SpecialReport",
            "component": 'specialReport/SpecialReport',
            "meta": { "key": "SpecialReport" }
        },
        {
            "path": "/edit/Laws",
            "name": "Laws",
            "component": 'laws/Laws',
            "meta": { "key": "Laws" }
        },
        {
            "path": "/edit/Rules",
            "name": "Rules",
            "component": 'rules/Rules',
            "meta": { "key": "Rules" }
        },
        {
            "path": "/edit/CustomPage",
            "name": "CustomPage",
            "component": 'customPage/CustomPage',
            "meta": { "key": "CustomPage" }
        },
        //疫情防控
        {
            "path": "/edit/Control",
            "name": "Control",
            "component": 'special/Control',
            "meta": { "key": "Control" }
        },
        //勤俭节约
        {
            "path": "/edit/Thrift",
            "name": "Thrift",
            "component": 'special/Thrift',
            "meta": { "key": "Thrift" }
        },
        //党史教育
        , {
            "path": "/edit/Education",
            "name": "Education",
            "component": 'special/Education',
            "meta": { "key": "Education" }
        }
        //办事公开
        , {
            "path": "/edit/OpenHome",
            "name": "OpenHome",
            "component": 'openHome/OpenHome',
            "meta": { "key": "OpenHome" },

        },
        //采购工作
        {
            "path": "/edit/Purchase",
            "name": "Purchase",
            "component": "purchase/Purchase",
            "meta": { "key": "Purchase" }
        },
        //三重一大
        {
            "path": "/edit/TripleBig",
            "name": "TripleBig",
            "component": "triplebig/TripleBig",
            "meta": { "key": "TripleBig" }
        },
        //经营管理
        {
            "path": "/edit/Management",
            "name": "Management",
            "component": 'management/Management',
            "meta": {
                "key": "Management"
            }
        },
        //专卖管理
        {
            "path": "/edit/Monopoly",
            "name": "Monopoly",
            "component": "monopoly/Monopoly",
            "meta": {
                "key": "Monopoly"
            }
        },
        //人事管理
        {
            "path": "/edit/Personnel",
            "name": "Personnel",
            "component": "personnel/Personnel",
            "meta": {
                "key": "Personnel"
            }
        },
        //规范管理监督考评
        {
            "path": "/edit/Standardize",
            "name": "Standardize",
            "component": "standardize/Standardize",
            "meta": {
                "key": "Standardize"
            }
        }
    ]
}];